/**
 * Routes
 */

const LoginSite = require("@/modules/login/components/LoginSite").default;
const RegisterSite = require("@/modules/login/components/RegisterSite").default;

const LoginRoutes = [
  {
    name: "login",
    path: "/login",
    component: LoginSite,
    meta: {
      header: false,
      footer: false,
    },
  },
  {
    name: "register",
    path: "/register",
    component: RegisterSite,
    meta: {
      header: false,
      footer: false,
    },
  },
];

const LoginSettingsRoutes = [];

const LoginBaseDataRoutes = [];

export { LoginRoutes, LoginSettingsRoutes, LoginBaseDataRoutes };
